import topic from '../topic'
export const mpotAPI = {
    getMpots: topic.mpotTopic + '/get_mpots',
    // getMpotById: topic.mpotTopic + '/get_mpot_by_id',
    // addMpot: topic.mpotTopic + '/add_mpot',
    // editMpot: topic.mpotTopic + '/edit_mpot',
    destroyMpotByIds: topic.mpotTopic + '/destroy_mpot_by_ids'
}